import * as React from 'react';
import { ICenterBase, IFollowUpSurveyShow } from '@nkr/models/index';
import { FollowUpSurveyListType } from '@nkr/enums/index';
import { Button, ButtonGroup, Col, ControlLabel, FormControl, FormGroup, Row, Well } from 'react-bootstrap';

interface IProps {
    listType: FollowUpSurveyListType,
    centerId: number,
    firstName: string,
    lastName: string,
    startDate: string,
    endDate: string,
    show: IFollowUpSurveyShow,
    isAdmin: boolean,
    centerList: ICenterBase[],
    onChange: (center: number, firstName: string, lastName: string, startDate: string, endDate: string, show: IFollowUpSurveyShow) => void,
    onSearch: () => void,
    onReset: () => void
}

const Search = (props: IProps) => {
    const handleTextChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        let { centerId, firstName, lastName, startDate, endDate, show } = props;

        if (e.currentTarget.name == 'firstName') {
            firstName = e.currentTarget.value;
        }

        if (e.currentTarget.name == 'lastName') {
            lastName = e.currentTarget.value;
        }

        if (e.currentTarget.name == 'startDate') {
            startDate = e.currentTarget.value;
        }

        if (e.currentTarget.name == 'endDate') {
            endDate = e.currentTarget.value;
        }

        props.onChange(centerId, firstName, lastName, startDate, endDate, show);
    };

    const handleShowChange = (property: string, value: boolean) => {
        let { centerId, firstName, lastName, startDate, endDate, show } = props;

        if (property == 'show6Month') {
            show.show6Month = value;
        }

        if (property == 'show12Month') {
            show.show12Month = value;
        }

        if (property == 'show24Month') {
            show.show24Month = value;
        }

        if (property == 'showOtherMonths') {
            show.showOtherMonths = value;
        }

        props.onChange(centerId, firstName, lastName, startDate, endDate, show);
    };

    const handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let { centerId, firstName, lastName, startDate, endDate, show } = props;

        props.onChange(parseInt(e.currentTarget.value), firstName, lastName, startDate, endDate, show);                           
    }
    
    // const handleReset = () => {
    //     let show = {
    //         show6Month: true,
    //         show12Month: true,
    //         show24Month: true,
    //         showOtherMonths: false
    //     };

    //     props.onChange(props.centerId, '', '', '', '', show);
    //     props.onSearch();
    // }

    return (
        <Well style={{ paddingTop: 9, paddingBottom: 9 }}>
            <Row>
                {props.isAdmin && (
                    <Col xs={12} sm={6} lg={3}>
                        <FormGroup>
                            <ControlLabel>Center</ControlLabel>
                            <FormControl
                                componentClass='select'
                                value={props.centerId}
                                onChange={handleCenterChange}
                            >
                                <option value={0}>- ALL -</option>
                                {props.centerList.map((item, index) =>
                                    <option key={'ctr-' + index} value={item.id}>{item.alias}</option>
                                )}
                            </FormControl>
                        </FormGroup>
                    </Col>
                )}

                <Col xs={12} sm={6} lg={3}>
                    <FormGroup>
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                            name='firstName'
                            value={props.firstName}
                            onChange={handleTextChange}
                        />
                    </FormGroup>
                </Col>

                <Col xs={12} sm={6} lg={3}>
                    <FormGroup>
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                            name='lastName'
                            value={props.lastName}
                            onChange={handleTextChange}
                        />
                    </FormGroup>
                </Col>

                <Col xs={12} lg={6}>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Survey Initiated Between Dates</Col>
                        <Col xs={5} sm={5}>
                            <FormControl
                                type='date'
                                name='startDate'
                                value={props.startDate}
                                onChange={handleTextChange}
                            />
                        </Col>
                        <label className='control-label text-center col-xs-1' style={{ paddingTop: 7 }}>&amp;</label>
                        <Col xs={5} sm={5}>
                            <FormControl
                                type='date'
                                name='endDate'
                                value={props.endDate}
                                onChange={handleTextChange}
                            />
                        </Col>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col xs={12} lg={6}>
                    <ButtonGroup>
                        <Button bsStyle={props.show.show6Month ? 'primary' : null} onClick={() => handleShowChange('show6Month', !props.show.show6Month)}>6-Month</Button>
                        <Button bsStyle={props.show.show12Month ? 'primary' : null} onClick={() => handleShowChange('show12Month', !props.show.show12Month)}>12-Month</Button>
                        <Button bsStyle={props.show.show24Month ? 'primary' : null} onClick={() => handleShowChange('show24Month', !props.show.show24Month)}>24-Month</Button>
                        <Button bsStyle={props.show.showOtherMonths ? 'primary' : 'default'} onClick={() => handleShowChange('showOtherMonths', !props.show.showOtherMonths)}>Other</Button>
                    </ButtonGroup>
                </Col>
                <Col xs={12} lg={2} lgOffset={2} className='text-right'>
                    <Button block bsStyle='primary' style={{ marginRight: 5 }} onClick={props.onSearch}>Search</Button>
                </Col>
                <Col xs={12} lg={2} className='text-right'>
                    <Button block onClick={props.onReset}>Reset Filters</Button>
                </Col>
            </Row>

            {/* <div>
                    {props.listType == MicrositeListType.PendingCards && props.canCreateCardBatch && (
                        <Button bsStyle='success' style={{ marginRight: 10 }} onClick={props.onCreateBatch}>Create Batch</Button>
                    )}

                    {(props.listType != MicrositeListType.PendingCards) && (
                        <Button style={{ marginRight: 30 }} onClick={props.onExport}>Export List</Button>
                    )}

                    <Button bsStyle='primary' onClick={props.onAdd}>Add Microsite</Button>
                </div> */}
        </Well >
    )
}

export default Search;